export default "__VITE_ASSET__Uq5u3K1d__"